import React, { useState } from 'react'
import { Button, message, Spin, Tooltip, Upload } from 'antd'
import { DeleteOutlined } from '@ant-design/icons'
import { RcFile } from 'antd/lib/upload'
import { removeCloak, removeSkin, uploadCloak, uploadSkin } from '../../api/customization'
import { toBase64 } from '../../api/utils'

export enum FileSelectType {
	Skin,
	Cloak
}

interface IFileSelectProps {
	type: FileSelectType
	onChanged: (deleted: boolean, isSlim: boolean|null) => void
}

// eslint-disable-next-line sonarjs/cognitive-complexity
export const FileSelect = ({ type, onChanged } : IFileSelectProps): React.ReactElement => {
	const [loading, setIsLoading] = useState(false)

	async function beforeUploadHandler(file: RcFile) {
		if (file.type !== 'image/png') {
			void message.error('Картинка должна иметь расширение .png!')
			setIsLoading(false)

			return false
		}

		if (type === FileSelectType.Skin) {
			const res = await uploadSkin(await toBase64(file))

			if (res.success) {
				void message.success('Скин успешно изменён!')

				onChanged(false, res.isSlim)
			} else {
				void message.error(res.message)
			}
		} else {
			const res = await uploadCloak(await toBase64(file))

			if (res.success) {
				void message.success('Плащ успешно изменён!')

				onChanged(false, null)
			} else {
				void message.error(res.message)
			}
		}

		setIsLoading(false)
		return false
	}

	async function remove() {
		if (type === FileSelectType.Skin) {
			const res = await removeSkin()

			if (res.success) {
				void message.success('Скин успешно удалён!')

				onChanged(true, false)
			} else {
				void message.error(res.message)
			}
		} else {
			const res = await removeCloak()

			if (res.success) {
				void message.success('Плащ успешно удалён!')

				onChanged(true, null)
			} else {
				void message.error(res.message)
			}
		}

		setIsLoading(false)
	}

	return (
		<div>
			{loading ? (
				<Spin style={{ marginRight: '12px' }}/>
			) : <></>}

			<Tooltip title="Принимаются файлы размером до 2мб и с расширением только .png">
				<Upload showUploadList={false} beforeUpload={file => {
					setIsLoading(true)
					return beforeUploadHandler(file)
				}}>
					<Button style={{ marginRight: '10px' }}>
                        Изменить
					</Button>
				</Upload>
			</Tooltip>
			<Button
				danger
				type="ghost"
				icon={<DeleteOutlined/>}
				shape="circle"
				onClick={() => {
					setIsLoading(true)
					void remove()
				}}
			/>
		</div>
	)
}
